'use client';

import React, { ComponentType, MouseEventHandler, CSSProperties } from "react";
import { registerComponent } from "../../lib/vulcan-lib/components";
import { forumSelect, ForumOptions } from "../../lib/forumTypeUtils";
import classNames from "classnames";
import { SpeakerWaveIcon } from "../icons/speakerWaveIcon";
import SparklesIcon from "@heroicons/react/24/solid/SparklesIcon";
import UserOutlineIcon from "@heroicons/react/24/outline/UserIcon";
import UserCircleIcon from "@heroicons/react/24/outline/UserCircleIcon";
import UsersOutlineIcon from "@heroicons/react/24/outline/UsersIcon";
import GiftIcon from "@heroicons/react/24/solid/GiftIcon";
import BellAlertIcon from "@heroicons/react/24/solid/BellAlertIcon";
import PlusIcon from "@heroicons/react/20/solid/PlusIcon";
import PlusSmallIcon from "@heroicons/react/20/solid/PlusSmallIcon";
import MinusSmallIcon from "@heroicons/react/20/solid/MinusSmallIcon";
import HeartIcon from "@heroicons/react/24/solid/HeartIcon";
import HeartOutlineIcon from "@heroicons/react/24/outline/HeartIcon";
import CheckCircleIcon from "@heroicons/react/20/solid/CheckCircleIcon";
import ChevronLeftIcon from "@heroicons/react/24/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/24/solid/ChevronRightIcon";
import ChevronDoubleLeftIcon from "@heroicons/react/24/outline/ChevronDoubleLeftIcon";
import ChevronDoubleRightIcon from "@heroicons/react/24/outline/ChevronDoubleRightIcon";
import CloseIcon from "@heroicons/react/24/solid/XMarkIcon";
import ClockIcon from "@heroicons/react/24/outline/ClockIcon";
import NoSymbolIcon from "@heroicons/react/24/solid/NoSymbolIcon";
import CalendarIcon from "@heroicons/react/24/solid/CalendarIcon";
import CalendarDaysIcon from "@heroicons/react/24/solid/CalendarDaysIcon";
import BriefcaseIcon from "@heroicons/react/24/solid/BriefcaseIcon";
import AcademicCapIcon from "@heroicons/react/24/solid/AcademicCapIcon";
import MapIcon from "@heroicons/react/24/outline/MapIcon";
import CommentIcon from "@heroicons/react/24/outline/ChatBubbleLeftIcon";
import CommentFilledIcon from "@heroicons/react/24/solid/ChatBubbleLeftIcon";
import ChatBubbleLeftRightIcon from "@heroicons/react/24/outline/ChatBubbleLeftRightIcon";
import ListBulletIcon from "@heroicons/react/24/outline/ListBulletIcon";
import TagFilledIcon from "@heroicons/react/24/solid/TagIcon";
import EyeSlashIcon from "@heroicons/react/24/solid/EyeSlashIcon";
import PencilIcon from "@heroicons/react/24/solid/PencilIcon";
import PencilSquareIcon from "@heroicons/react/24/outline/PencilSquareIcon";
import EnvelopeIcon from "@heroicons/react/24/outline/EnvelopeIcon";
import PhotoIcon from "@heroicons/react/24/outline/PhotoIcon";
import DocumentTextIcon from "@heroicons/react/24/outline/DocumentTextIcon";
import DocumentIcon from "@heroicons/react/24/solid/DocumentIcon";
import ChartBarIcon from "@heroicons/react/24/solid/ChartBarIcon";
import ClipboardDocumentListIcon from "@heroicons/react/24/outline/ClipboardDocumentListIcon";
import ClipboardDocumentIcon from "@heroicons/react/24/outline/ClipboardDocumentIcon";
import QuestionMarkCircleIcon from "@heroicons/react/24/outline/QuestionMarkCircleIcon";
import QuestionMarkCircleFilledIcon from "@heroicons/react/24/solid/QuestionMarkCircleIcon";
import ArrowLongDown from "@heroicons/react/20/solid/ArrowLongDownIcon";
import ArrowLongUp from "@heroicons/react/20/solid/ArrowLongUpIcon";
import BookOpenIcon from "@heroicons/react/24/outline/BookOpenIcon";
import ComputerDesktopIcon from "@heroicons/react/24/outline/ComputerDesktopIcon";
import ArrowRightIcon from "@heroicons/react/24/solid/ArrowRightIcon";
import ArrowRightOutlineIcon from "@heroicons/react/24/outline/PaperAirplaneIcon";
import { PublishSettingsIcon } from "../icons/publishSettingsIcon";
import ArrowLeftIcon from "@heroicons/react/24/solid/ArrowLeftIcon";
import ArrowCircleIcon from "@heroicons/react/20/solid/ArrowPathRoundedSquareIcon";
import BarsArrowDown from "@heroicons/react/24/outline/BarsArrowDownIcon";
import Bars3 from "@heroicons/react/24/outline/Bars3Icon";
import ViewColumnsIcon from "@heroicons/react/24/outline/ViewColumnsIcon";
import InformationCircleIcon from '@heroicons/react/24/solid/InformationCircleIcon';
import ArrowDownOnSquareIcon from '@heroicons/react/24/outline/ArrowDownOnSquareIcon';
import ChevronUpDownIcon from "@heroicons/react/24/outline/ChevronUpDownIcon";
import ArrowsUpDownIcon from "@heroicons/react/20/solid/ArrowsUpDownIcon";
import MuiBookmarkIcon from "@/lib/vendor/@material-ui/icons/src/Bookmark";
import MuiBookmarkBorderIcon from "@/lib/vendor/@material-ui/icons/src/BookmarkBorder";
import MuiBookmarksIcon from "@/lib/vendor/@material-ui/icons/src/Bookmarks";
import MuiBellBorderIcon from "@/lib/vendor/@material-ui/icons/src/NotificationsNone";
import MuiStarIcon from "@/lib/vendor/@material-ui/icons/src/Star";
import MuiStarBorderIcon from "@/lib/vendor/@material-ui/icons/src/StarBorder";
import MuiPersonIcon from "@/lib/vendor/@material-ui/icons/src/Person";
import MuiPeopleIcon from "@/lib/vendor/@material-ui/icons/src/People";
import MuiGroupAddIcon from "@/lib/vendor/@material-ui/icons/src/GroupAdd";
import MuiNotificationsIcon from '@/lib/vendor/@material-ui/icons/src/Notifications';
import MuiLinkIcon from "@/lib/vendor/@material-ui/icons/src/Link";
import MuiTagIcon from "@/lib/vendor/@material-ui/icons/src/LocalOfferOutlined";
import MuiReportIcon from "@/lib/vendor/@material-ui/icons/src/ReportOutlined";
import MuiVisibilityOff from "@/lib/vendor/@material-ui/icons/src/VisibilityOff";
import MuiVisibility from "@/lib/vendor/@material-ui/icons/src/Visibility";
import MuiEditIcon from "@/lib/vendor/@material-ui/icons/src/Edit";
import MuiShowChartIcon from "@/lib/vendor/@material-ui/icons/src/ShowChart";
import MuiInsightsIcon from "@/lib/vendor/@material-ui/icons/src/Insights";
import MuiNotesIcon from "@/lib/vendor/@material-ui/icons/src/Notes";
import MuiWarningIcon from "@/lib/vendor/@material-ui/icons/src/Warning";
import MuiLocationIcon from "@/lib/vendor/@material-ui/icons/src/LocationOn";
import MuiSettingsIcon from "@/lib/vendor/@material-ui/icons/src/Settings";
import MuiEmailIcon from "@/lib/vendor/@material-ui/icons/src/Email";
import MuiPuzzleIcon from "@/lib/vendor/@material-ui/icons/src/Extension";
import MuiCheckIcon from "@/lib/vendor/@material-ui/icons/src/Check";
import MuiEllipsisVerticalIcon from "@/lib/vendor/@material-ui/icons/src/MoreVert";
import MuiShareIcon from "@/lib/vendor/@material-ui/icons/src/Share";
import MuiSearchIcon from '@/lib/vendor/@material-ui/icons/src/Search';
import MuiMenuIcon from "@/lib/vendor/@material-ui/icons/src/Menu";
import MuiForumIcon from '@/lib/vendor/@material-ui/icons/src/Forum';
import MuiVoteIcon from '@/lib/vendor/@material-ui/icons/src/HowToVote'
import MuiNotInterestedIcon from '@/lib/vendor/@material-ui/icons/src/NotInterested';
import MuiExpandMoreIcon from "@/lib/vendor/@material-ui/icons/src/ExpandMore";
import MuiExpandLessIcon from "@/lib/vendor/@material-ui/icons/src/ExpandLess";
import MuiPlaylistAddIcon from "@/lib/vendor/@material-ui/icons/src/PlaylistAdd";
import PlusOneIcon from '@/lib/vendor/@material-ui/icons/src/PlusOne';
import MuiReplayIcon from "@/lib/vendor/@material-ui/icons/src/Replay";
import UndoIcon from '@/lib/vendor/@material-ui/icons/src/Undo';
import ClearIcon from '@/lib/vendor/@material-ui/icons/src/Clear';
import FullscreenIcon from '@/lib/vendor/@material-ui/icons/src/Fullscreen';
import FullscreenExitIcon from '@/lib/vendor/@material-ui/icons/src/FullscreenExit';
import MuiArrowDownRightIcon from '@/lib/vendor/@material-ui/icons/src/SubdirectoryArrowRight';
import MuiDragIndicatorIcon from '@/lib/vendor/@material-ui/icons/src/DragIndicator';
import MuiNoteAddOutlinedIcon from '@/lib/vendor/@material-ui/icons/src/NoteAddOutlined';
import ThumbsUpIcon from '@/lib/vendor/@material-ui/icons/src/ThumbUp';
import ThumbUpOutlineIcon from '@/lib/vendor/@material-ui/icons/src/ThumbUpOutlined';
import CopyIcon from "@heroicons/react/24/outline/DocumentDuplicateIcon";
import MuiAddIcon from "@/lib/vendor/@material-ui/icons/src/Add";
import BookIcon from "@heroicons/react/24/solid/BookOpenIcon";
import MuiPostIcon from "@/lib/vendor/@material-ui/icons/src/Description";
import MuiCommentIcon from "@/lib/vendor/@material-ui/icons/src/Message";
import MuiSnoozeIcon from "@/lib/vendor/@material-ui/icons/src/Snooze";
import MuiFlagIcon from "@/lib/vendor/@material-ui/icons/src/Flag";
import MuiDeleteIcon from "@/lib/vendor/@material-ui/icons/src/Delete";
import MuiOpenInNewIcon from "@/lib/vendor/@material-ui/icons/src/OpenInNew";
import MuiCloudOffIcon from "@/lib/vendor/@material-ui/icons/src/CloudOff";

/**
 * ForumIcon can be used with custom SVG elements but you MUST pass through
 * the props using React.HTMLAttributes otherwise you will have bugs. See the
 * files below for examples
 */
import { AuthorIcon } from "../icons/authorIcon";
import { SproutIcon } from "../icons/sproutIcon";
import { StickyIcon } from "../icons/stickyIcon";
import { ThickChevronLeftIcon } from "../icons/thickChevronLeftIcon";
import { ThickChevronRightIcon } from "../icons/thickChevronRightIcon";
import { ThickChevronDownIcon } from "../icons/thickChevronDownIcon";
import { CardIcon } from "../icons/cardIcon";
import { ListIcon } from "../icons/listIcon";
import { AddEmojiIcon } from "../icons/addEmoji";
import { SoftUpArrowIcon } from "../icons/softUpArrowIcon";
import { CloseMenuIcon } from "../icons/closeMenuIcon";
import { BoldLinkIcon } from "../icons/boldLink";
import { QIcon } from "../icons/qIcon";
import { FilterAlt } from "../icons/filteralt";
import { VotedIcon } from "../icons/votedIcon";
import { LightbulbChatIcon } from "../icons/lightbulbChatIcon";
import { AddReactionIcon } from "../icons/AddReactionIcon";
import { LabBeakerIcon } from "../icons/LabBeakerIcon";
import { SparkleIcon } from "../icons/sparkleIcon";
import { ListViewIcon } from "../icons/ListViewIcon";
import { CardViewIcon } from "../icons/CardViewIcon";
import { CheckSmallIcon } from "../icons/CheckSmallIcon";
import { FilterBarsIcon } from "../icons/FilterBarsIcon";
import { EAEnvelopeIcon } from "../icons/EAEnvelopeIcon";
import { RobotIcon } from '../icons/RobotIcon';
import { TickReactionIcon } from "../icons/reactions/TickReactionIcon";
import { CrossReactionIcon } from "../icons/reactions/CrossReactionIcon";
import { CrossReactionCapIcon } from "../icons/CrossReactionCapIcon";
import { GivingHandIcon } from "../icons/GivingHandIcon";
import { DictionaryIcon } from "../icons/Dictionary";
import { QuestionMarkIcon } from "../icons/QuestionMarkIcon";
import MuiArrowForwardIcon from "@/lib/vendor/@material-ui/icons/src/ArrowForward";
import MuiVolumeUpIcon from "@/lib/vendor/@material-ui/icons/src/VolumeUp";
import { defineStyles, useStyles } from "../hooks/useStyles";

/**
 * This exists to allow us to easily use different icon sets on different
 * forums. To add a new icon, add its name to `ForumIconName` and add an
 * icon component to each option in `ICONS`. `default` generally uses icons
 * from MaterialUI and `EAForum` generally uses icons from HeroIcons.
 */
export type ForumIconName =
  "VolumeUp" |
  "VolumeUpBookUI" |
  "GivingHand" |
  "BookOpen" |
  "Bookmark" |
  "BookmarkBorder" |
  "Bookmarks" |
  "Sparkles" |
  "Karma" |
  "KarmaOutline" |
  "Star" |
  "User" |
  "UserOutline" |
  "UserCircle" |
  "Users" |
  "UsersOutline" |
  "GroupAdd" |
  "Gift" |
  "Bell" |
  "BellAlert" |
  "BellBorder" |
  "AddEmoji" |
  "Link" |
  "BoldLink" |
  "Pin" |
  "Author" |
  "Sprout" |
  "Close" |
  "Clock" |
  "No" |
  "Calendar" |
  "CalendarDays" |
  "Work" |
  "School" |
  "MapPin" |
  "Map" |
  "Pencil" |
  "PencilSquare" |
  "Comment" |
  "CommentFilled" |
  "ChatBubbleLeftRight" |
  "ChatBubbleLeftRightFilled" |
  "Shortform" |
  "Warning" |
  "Report" |
  "ListBullet" |
  "Eye" |
  "EyeSlash" |
  "EyeOutline" |
  "Tag" |
  "TagFilled" |
  "Edit" |
  "Analytics" |
  "ChevronLeft" |
  "ChevronRight" |
  "ChevronDoubleLeft" |
  "ChevronDoubleRight" |
  "ThickChevronLeft" |
  "ThickChevronRight" |
  "ThickChevronDown" |
  "ChevronUpDown" |
  "ArrowsUpDown" |
  "NarrowArrowDown" |
  "NarrowArrowUp" |
  "Plus" |
  "Check" |
  "CheckCircle" |
  "CheckSmall" |
  "Card" |
  "List" |
  "PlusSmall" |
  "MinusSmall" |
  "Heart" |
  "HeartOutline" |
  "Settings" |
  "Email" |
  "Envelope" |
  "EAEnvelope" |
  "Puzzle" |
  "Image" |
  "Document" |
  "DocumentFilled" |
  "SoftUpArrow" |
  "ArrowLeft" |
  "ArrowForward" |
  "ArrowRight" |
  "ArrowRightOutline" |
  "PublishSettings" |
  "ArrowCircle" |
  "Autorenew" |
  "EllipsisVertical" |
  "Share" |
  "ClipboardDocumentList" |
  "ClipboardDocument" |
  "QuestionMarkCircle" |
  "QuestionMarkCircleFilled" |
  "QuestionMark" |
  "Search" |
  "ComputerDesktop" |
  "Menu" |
  "CloseMenu" |
  "Q" |
  "BarChart" |
  "Insights" |
  "Funnel" |
  "FilterBars" |
  "Voted" |
  "InfoCircle" |
  "BarsArrowDown" |
  "Bars3" |
  "ViewColumns" |
  "ListView" |
  "CardView" |
  "LightbulbChat" |
  "VoteBallot" |
  "Import" |
  "AddReaction" |
  "LabBeaker" |
  "Sparkle" |
  "NotInterested" |
  "Robot" |
  "ExpandMore" |
  "ExpandLess" |
  "PlaylistAdd"|
  "PlusOne" |
  "Undo" |
  "Clear" |
  "Fullscreen" |
  "FullscreenExit" |
  "TickReaction" |
  "CrossReaction" |
  "CrossReactionCap" |
  "Add" |
  "Copy" |
  "Book" |
  "Dictionary" |
  "ArrowDownRight" |
  "DragIndicator" |
  "NoteAdd" |
  "ThumbUp" |
  "ThumbUpOutline" |
  "Post" |
  "ModDashboardComment" |
  "Snooze" |
  "Flag" |
  "Delete" |
  "OpenInNew" |
  "CloudOff";

const icons: Record<ForumIconName, IconComponent> = {
  VolumeUp: SpeakerWaveIcon,
  VolumeUpBookUI: MuiVolumeUpIcon,
  GivingHand: GivingHandIcon,
  BookOpen: BookOpenIcon,
  Bookmark: MuiBookmarkIcon,
  BookmarkBorder: MuiBookmarkBorderIcon,
  Bookmarks: MuiBookmarksIcon,
  Sparkles: SparklesIcon,
  Karma: MuiStarIcon,
  KarmaOutline: MuiStarBorderIcon,
  Star: MuiStarIcon,
  User: MuiPersonIcon,
  UserOutline: UserOutlineIcon,
  UserCircle: UserCircleIcon,
  Users: MuiPeopleIcon,
  UsersOutline: UsersOutlineIcon,
  GroupAdd: MuiGroupAddIcon,
  Gift: GiftIcon,
  Bell: MuiNotificationsIcon,
  BellAlert: BellAlertIcon,
  BellBorder: MuiBellBorderIcon,
  AddEmoji: AddEmojiIcon,
  Link: MuiLinkIcon,
  BoldLink: BoldLinkIcon,
  Pin: StickyIcon,
  Author: AuthorIcon,
  Sprout: SproutIcon,
  Close: CloseIcon,
  Clock: ClockIcon,
  No: NoSymbolIcon,
  Calendar: CalendarIcon,
  CalendarDays: CalendarDaysIcon,
  Work: BriefcaseIcon,
  School: AcademicCapIcon,
  MapPin: MuiLocationIcon,
  Map: MapIcon,
  Pencil: PencilIcon,
  PencilSquare: PencilSquareIcon,
  Comment: CommentIcon,
  CommentFilled: CommentFilledIcon,
  ChatBubbleLeftRight: ChatBubbleLeftRightIcon,
  ChatBubbleLeftRightFilled: MuiForumIcon,
  Shortform: MuiNotesIcon,
  Warning: MuiWarningIcon,
  ListBullet: ListBulletIcon,
  Report: MuiReportIcon,
  Tag: MuiTagIcon,
  TagFilled: TagFilledIcon,
  Eye: MuiVisibility,
  EyeSlash: EyeSlashIcon,
  EyeOutline: MuiVisibilityOff,
  Edit: MuiEditIcon,
  Analytics: MuiShowChartIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  ChevronDoubleLeft: ChevronDoubleLeftIcon,
  ChevronDoubleRight: ChevronDoubleRightIcon,
  ThickChevronLeft: ThickChevronLeftIcon,
  ThickChevronRight: ThickChevronRightIcon,
  ThickChevronDown: ThickChevronDownIcon,
  ChevronUpDown: ChevronUpDownIcon,
  ArrowsUpDown: ArrowsUpDownIcon,
  NarrowArrowDown: ArrowLongDown,
  NarrowArrowUp: ArrowLongUp,
  Plus: PlusIcon,
  PlusSmall: PlusSmallIcon,
  MinusSmall: MinusSmallIcon,
  Heart: HeartIcon,
  HeartOutline: HeartOutlineIcon,
  Settings: MuiSettingsIcon,
  Email: MuiEmailIcon,
  Envelope: EnvelopeIcon,
  EAEnvelope: EAEnvelopeIcon,
  Image: PhotoIcon,
  Document: DocumentTextIcon,
  DocumentFilled: DocumentIcon,
  Puzzle: MuiPuzzleIcon,
  Check: MuiCheckIcon,
  CheckCircle: CheckCircleIcon,
  CheckSmall: CheckSmallIcon,
  Card: CardIcon,
  List: ListIcon,
  SoftUpArrow: SoftUpArrowIcon,
  ArrowRight: ArrowRightIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowForward: MuiArrowForwardIcon,
  ArrowRightOutline: ArrowRightOutlineIcon,
  PublishSettings: PublishSettingsIcon,
  ArrowCircle: ArrowCircleIcon,
  Autorenew: MuiReplayIcon,
  EllipsisVertical: MuiEllipsisVerticalIcon,
  Share: MuiShareIcon,
  ClipboardDocumentList: ClipboardDocumentListIcon,
  ClipboardDocument: ClipboardDocumentIcon,
  QuestionMarkCircle: QuestionMarkCircleIcon,
  QuestionMarkCircleFilled: QuestionMarkCircleFilledIcon,
  QuestionMark: QuestionMarkIcon,
  Search: MuiSearchIcon,
  ComputerDesktop: ComputerDesktopIcon,
  Menu: MuiMenuIcon,
  CloseMenu: CloseMenuIcon,
  Q: QIcon,
  BarChart: ChartBarIcon,
  Insights: MuiInsightsIcon,
  Funnel: FilterAlt,
  FilterBars: FilterBarsIcon,
  Voted: VotedIcon,
  InfoCircle: InformationCircleIcon,
  BarsArrowDown: BarsArrowDown,
  Bars3: Bars3,
  ViewColumns: ViewColumnsIcon,
  ListView: ListViewIcon,
  CardView: CardViewIcon,
  LightbulbChat: LightbulbChatIcon,
  VoteBallot: MuiVoteIcon,
  Import: ArrowDownOnSquareIcon,
  AddReaction: AddReactionIcon,
  LabBeaker: LabBeakerIcon,
  Sparkle: SparkleIcon,
  NotInterested: MuiNotInterestedIcon,
  Robot: RobotIcon,
  ExpandMore: MuiExpandMoreIcon,
  ExpandLess: MuiExpandLessIcon,
  PlaylistAdd: MuiPlaylistAddIcon,
  PlusOne: PlusOneIcon,
  Undo: UndoIcon,
  Clear: ClearIcon,
  Fullscreen: FullscreenIcon,
  FullscreenExit: FullscreenExitIcon,
  TickReaction: TickReactionIcon,
  CrossReaction: CrossReactionIcon,
  CrossReactionCap: CrossReactionCapIcon,
  Add: MuiAddIcon,
  Copy: CopyIcon,
  Book: BookIcon,
  Dictionary: DictionaryIcon,
  ArrowDownRight: MuiArrowDownRightIcon,
  DragIndicator: MuiDragIndicatorIcon,
  NoteAdd: MuiNoteAddOutlinedIcon,
  ThumbUp: ThumbsUpIcon,
  ThumbUpOutline: ThumbUpOutlineIcon,
  Post: MuiPostIcon,
  ModDashboardComment: MuiCommentIcon,
  Snooze: MuiSnoozeIcon,
  Flag: MuiFlagIcon,
  Delete: MuiDeleteIcon,
  OpenInNew: MuiOpenInNewIcon,
  CloudOff: MuiCloudOffIcon,
};

type IconProps = {
  className?: string,
  onClick?: MouseEventHandler<SVGElement>,
  onMouseDown?: MouseEventHandler<SVGElement>,
}

type IconComponent = ComponentType<Partial<IconProps>>;

const styles = defineStyles("ForumIcon", (_: ThemeType) => ({
  root: {
    userSelect: "none",
    display: "inline-block",
    flexShrink: 0,
    width: "var(--icon-size, 1em)",
    height: "var(--icon-size, 1em)",
    fontSize: "var(--icon-size, 24px)",
  },
  linkRotation: {
    transform: "rotate(-45deg)",
    '&.MuiListItemIcon-root': {
      marginRight: 12
    }
  },
}), {
  stylePriority: -2,
});

type IconClassName = "root"|"linkRotation"

// This is a map from forum types to icon names to keys in the `styles` object.
const CUSTOM_CLASSES: ForumOptions<Partial<Record<ForumIconName, IconClassName>>> = {
  default: {
    Link: "linkRotation",
  },
  EAForum: {
  },
};

type ForumIconProps = IconProps & {
  icon: ForumIconName,
  noDefaultStyles?: boolean,
  style?: CSSProperties,
};

/**
 * An icon, drawn from a table of icons with some forum/theme-specific variants.
 *
 * WARNING: There is a Safari-specific bug, which affects what styles you can
 * safely use in a `className` that you pass in. Historically, the default was
 * that an icon had a default fontSize of 24px and a default width and height
 * of 1em, which is equal to the font size, so you could override fontSize alone
 * to get a square icon of any size. Unfortunately, in Safari, an `em` on an
 * SVG is an inconsistent unit which fails to scale with the zoom level.
 *
 * In the common case of a square icon, you can override the CSS variable
 * --icon-size and this will adjust all three attributes at once. Eg:
 *     myClassname: {
 *       "--icon-size": "18px"
 *     }
 * Note that you must specify the unit (px); a number alone will not work.
 */
const ForumIcon = ({
  icon,
  noDefaultStyles,
  className,
  ...props
}: ForumIconProps) => {
  const classes = useStyles(styles);
  const Icon = icons[icon];
  if (!Icon) {
    // eslint-disable-next-line no-console
    console.error(`Invalid ForumIcon name: ${icon}`);
    return null;
  }

  const customClassKey = forumSelect(CUSTOM_CLASSES)[icon];
  const customClass = customClassKey ? classes[customClassKey] : undefined;
  const fullClassName = classNames(
    className,
    !noDefaultStyles && classes.root,
    !noDefaultStyles && customClass
  );

  return <Icon className={fullClassName} {...props} />;
}

export default registerComponent("ForumIcon", ForumIcon, {
  areEqual: "auto",
});
